
<div *ngIf="asFormsControl().currency"
	 class="app-input prefix">
		<div class="infix">
			{{ asFormsControl().currency }}
		</div>
</div>

<mat-form-field
  [ngClass]="{'fill': asFormsControl().currency}"
  [appearance]="asFormsControl().outline ? 'outline' : 'legacy'"
  class="app-input"
>
  <mat-label *ngIf="asFormsControl().outline && !asFormsControl().floatingLabelNever">{{ asFormsControl().placeholder }}</mat-label>

  <input
    matInput
    #input
    autocomplete="off"
    [placeholder]="asFormsControl().placeholder"
    [disabled]="asFormsControl().disabled"
    [readonly]="asFormsControl().readonly"
    (focus)="onTouched && onTouched()"
    (blur)="convertToFloat($event)"
    (click)="moveCaretToEnd($event)"
    (keypress)="onKeyPress($event)"
    (keyup)="onKeyUp($event)"
    (paste)="onPaste($event)"
  >
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
  <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
